import React from 'react';

export default function About() {

    return (
        <div>
            <p>This website is for members only</p>
        </div>
    );
}